import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { OrderLine } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-floating-cart-product-list',
  templateUrl: './floating-cart-product-list.component.html',
  styleUrls: ['./floating-cart-product-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FloatingCartProductListComponent implements OnInit {
  public hiddenProduct: Object = {};

  constructor() {}

  @Input()
  orderLines;

  @Output()
  onEmptyCart = new EventEmitter<OrderLine>();
  // used for the demo - to be removed
  @Output()
  onRemoveProduct = new EventEmitter<OrderLine>();
  @Output()
  onClosePreviewBox = new EventEmitter();

  ngOnInit() {}

  onRemove(orderLine: OrderLine) {
    this.hiddenProduct[orderLine.id] = true;
    this.onRemoveProduct.emit(orderLine);
    if (Object.keys(this.orderLines).length === Object.keys(this.hiddenProduct).length) {
      // used for the demo - to be removed
      this.onEmptyCart.emit(orderLine);
    }
  }

  resetBox() {
    this.onClosePreviewBox.emit(true);
  }
}
